
import { useContext } from 'react';
import { DataContext } from '../data/DataContext';
import { CSSProperties } from 'react'
import { IconFinish } from '../img'
import http from '../../../services/http';
import { endPoints } from '../../../utils/constanst';
import { useModal } from '../hook/useModal';
import { ModalMsgCtrl } from '../components'
import { IsPro } from '../data/Help'
import { EncryptData } from '../../../utils/helpMain'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Step7 = () => {

    const { AutoCR } = useContext(DataContext);
    const modalLoading = useModal({ isloading: true } as IModalProps);


    const styleCenter: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    const newOfert = () => { modalLoading.show(); window.location.reload() }
    const downloadReport = (event: any) => {
        event.preventDefault();
        modalLoading.setTextLoading(`Descargando oferta #${AutoCR.idPoliza}`);
        http(endPoints.descargarOferta(AutoCR.idPoliza)).get().finally(() => modalLoading.hide());
    }

    const copyUrl = (event: any) => {
        event.preventDefault();
        let path = window.location.pathname;
        if(path.endsWith('/'))
            path = path.substring(0, path.length - 1)
        navigator.clipboard.writeText(`${window.location.origin}${path}/emision/${EncryptData(AutoCR.idPoliza.toString())}`);
        toast("URL copiado");
    }


    return (
        <>
            <div style={{ ...styleCenter }} className='lbl-input-auto-cr mt-20'>
                <label style={{ fontSize: '18px', fontWeight: 600 }}>Oferta No. {AutoCR.idPoliza}</label>
            </div>
            <div style={styleCenter} className='mt-20'>
                <IconFinish />
            </div>
            <div style={{ ...styleCenter, textAlign: 'center', lineHeight: '20px' }} className='mt-20 lbl-input-auto-cr '>
                <label>
                    Se ha descargado la oferta en tu <br></br> dispositivo y también la hemos <br></br> enviado a tu correo electrónico.
                </label>
            </div>
            <div style={{ ...styleCenter, textAlign: 'center', lineHeight: '20px' }} className='mt-20 lbl-input-auto-cr '>
                <label>
                    Para finalizar la compra, ingresa este <br></br> número de oferta en Seguronet o <br></br> bien da clic en “Emitir” para continuar <br></br> con el proceso.
                </label>
            </div>
            <div className='mt-20' style={{ display: 'flex', justifyContent: 'space-around' }}>
                <button
                    className='btn-auto-cr back mr-10 ml-10'
                    style={{ width: '100%', background: '#D7D7D7', border: 'none', color: '#4D4D4D', fontWeight: 500 }}
                    onClick={newOfert}
                >
                    Nueva oferta
                </button>
                <button className='btn-auto-cr next mr-10 ml-10' style={{ width: '100%', fontWeight: 500 }} onClick={downloadReport}>Descargar oferta</button>
            </div>
            {/* {IsPro() === false && */}
                <>
                    <div style={{ ...styleCenter, textAlign: 'center', lineHeight: '20px', color: '#008866', fontWeight: 600 }} className='mt-20 lbl-input-auto-cr '>
                        <label>
                            ¿El cliente desea emitir?
                        </label>
                    </div>
                    <div style={{ ...styleCenter, textAlign: 'center', lineHeight: '20px' }} className='mt-10 lbl-input-auto-cr '>
                        <label>
                            En caso de querer continuar con el <br></br> proceso de emisión, favor enviar este <br></br> link al cliente
                        </label>
                    </div>
                    <div style={styleCenter} className='mt-40'>
                        <button className='btn-auto-cr next' onClick={copyUrl}>Copiar URL</button>
                    </div>
                </>
            {/* } */}
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
            <ToastContainer  
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
                progressStyle={{background:'#008866'}}
                bodyStyle={{
                    color:'#4D4D4D',
                    textAlign:'center'
                }}
                limit={1}
            />
        </>
    )
}


export { Step7 }